
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $f993037a9863bffd$exports = {};
!function(t, n) {
    $f993037a9863bffd$exports = n();
}("undefined" != typeof self ? self : $f993037a9863bffd$exports, function() {
    return function() {
        "use strict";
        var t = {
            407: function(t, n, e) {
                e.d(n, {
                    default: function() {
                        return N;
                    }
                });
                var o = /([:*])(\w+)/g, r = /\*/g, i = /\/\?/g;
                function a(t) {
                    return void 0 === t && (t = "/"), v() ? location.pathname + location.search + location.hash : t;
                }
                function s(t) {
                    return t.replace(/\/+$/, "").replace(/^\/+/, "");
                }
                function c(t) {
                    return "string" == typeof t;
                }
                function u(t) {
                    return t && t.indexOf("#") >= 0 && t.split("#").pop() || "";
                }
                function h(t) {
                    var n = s(t).split(/\?(.*)?$/);
                    return [
                        s(n[0]),
                        n.slice(1).join("")
                    ];
                }
                function f(t) {
                    for(var n = {}, e = t.split("&"), o = 0; o < e.length; o++){
                        var r = e[o].split("=");
                        if ("" !== r[0]) {
                            var i = decodeURIComponent(r[0]);
                            n[i] ? (Array.isArray(n[i]) || (n[i] = [
                                n[i]
                            ]), n[i].push(decodeURIComponent(r[1] || ""))) : n[i] = decodeURIComponent(r[1] || "");
                        }
                    }
                    return n;
                }
                function l(t, n) {
                    var e, a = h(s(t.currentLocationPath)), l = a[0], p = a[1], d = "" === p ? null : f(p), v = [];
                    if (c(n.path)) {
                        if (e = "(?:/^|^)" + s(n.path).replace(o, function(t, n, e) {
                            return v.push(e), "([^/]+)";
                        }).replace(r, "?(?:.*)").replace(i, "/?([^/]+|)") + "$", "" === s(n.path) && "" === s(l)) return {
                            url: l,
                            queryString: p,
                            hashString: u(t.to),
                            route: n,
                            data: null,
                            params: d
                        };
                    } else e = n.path;
                    var g = new RegExp(e, ""), m = l.match(g);
                    if (m) {
                        var y = c(n.path) ? function(t, n) {
                            return 0 === n.length ? null : t ? t.slice(1, t.length).reduce(function(t, e, o) {
                                return null === t && (t = {}), t[n[o]] = decodeURIComponent(e), t;
                            }, null) : null;
                        }(m, v) : m.groups ? m.groups : m.slice(1);
                        return {
                            url: s(l.replace(new RegExp("^" + t.instance.root), "")),
                            queryString: p,
                            hashString: u(t.to),
                            route: n,
                            data: y,
                            params: d
                        };
                    }
                    return !1;
                }
                function p() {
                    return !("undefined" == typeof window || !window.history || !window.history.pushState);
                }
                function d(t, n) {
                    return void 0 === t[n] || !0 === t[n];
                }
                function v() {
                    return "undefined" != typeof window;
                }
                function g(t, n) {
                    return void 0 === t && (t = []), void 0 === n && (n = {}), t.filter(function(t) {
                        return t;
                    }).forEach(function(t) {
                        [
                            "before",
                            "after",
                            "already",
                            "leave"
                        ].forEach(function(e) {
                            t[e] && (n[e] || (n[e] = []), n[e].push(t[e]));
                        });
                    }), n;
                }
                function m(t, n, e) {
                    var o = n || {}, r = 0;
                    !function n() {
                        t[r] ? Array.isArray(t[r]) ? (t.splice.apply(t, [
                            r,
                            1
                        ].concat(t[r][0](o) ? t[r][1] : t[r][2])), n()) : t[r](o, function(t) {
                            void 0 === t || !0 === t ? (r += 1, n()) : e && e(o);
                        }) : e && e(o);
                    }();
                }
                function y(t, n) {
                    void 0 === t.currentLocationPath && (t.currentLocationPath = t.to = a(t.instance.root)), t.currentLocationPath = t.instance._checkForAHash(t.currentLocationPath), n();
                }
                function _(t, n) {
                    for(var e = 0; e < t.instance.routes.length; e++){
                        var o = l(t, t.instance.routes[e]);
                        if (o && (t.matches || (t.matches = []), t.matches.push(o), "ONE" === t.resolveOptions.strategy)) return void n();
                    }
                    n();
                }
                function k(t, n) {
                    t.navigateOptions && (void 0 !== t.navigateOptions.shouldResolve && console.warn('"shouldResolve" is deprecated. Please check the documentation.'), void 0 !== t.navigateOptions.silent && console.warn('"silent" is deprecated. Please check the documentation.')), n();
                }
                function O(t, n) {
                    !0 === t.navigateOptions.force ? (t.instance._setCurrent([
                        t.instance._pathToMatchObject(t.to)
                    ]), n(!1)) : n();
                }
                m.if = function(t, n, e) {
                    return Array.isArray(n) || (n = [
                        n
                    ]), Array.isArray(e) || (e = [
                        e
                    ]), [
                        t,
                        n,
                        e
                    ];
                };
                var w = v(), L = p();
                function b(t, n) {
                    if (d(t.navigateOptions, "updateBrowserURL")) {
                        var e = ("/" + t.to).replace(/\/\//g, "/"), o = w && t.resolveOptions && !0 === t.resolveOptions.hash;
                        L ? (history[t.navigateOptions.historyAPIMethod || "pushState"](t.navigateOptions.stateObj || {}, t.navigateOptions.title || "", o ? "#" + e : e), location && location.hash && (t.instance.__freezeListening = !0, setTimeout(function() {
                            if (!o) {
                                var n = location.hash;
                                location.hash = "", location.hash = n;
                            }
                            t.instance.__freezeListening = !1;
                        }, 1))) : w && (window.location.href = t.to);
                    }
                    n();
                }
                function A(t, n) {
                    var e = t.instance;
                    e.lastResolved() ? m(e.lastResolved().map(function(n) {
                        return function(e, o) {
                            if (n.route.hooks && n.route.hooks.leave) {
                                var r = !1, i = t.instance.matchLocation(n.route.path, t.currentLocationPath, !1);
                                r = "*" !== n.route.path ? !i : !(t.matches && t.matches.find(function(t) {
                                    return n.route.path === t.route.path;
                                })), d(t.navigateOptions, "callHooks") && r ? m(n.route.hooks.leave.map(function(n) {
                                    return function(e, o) {
                                        return n(function(n) {
                                            !1 === n ? t.instance.__markAsClean(t) : o();
                                        }, t.matches && t.matches.length > 0 ? 1 === t.matches.length ? t.matches[0] : t.matches : void 0);
                                    };
                                }).concat([
                                    function() {
                                        return o();
                                    }
                                ])) : o();
                            } else o();
                        };
                    }), {}, function() {
                        return n();
                    }) : n();
                }
                function P(t, n) {
                    d(t.navigateOptions, "updateState") && t.instance._setCurrent(t.matches), n();
                }
                var R = [
                    function(t, n) {
                        var e = t.instance.lastResolved();
                        if (e && e[0] && e[0].route === t.match.route && e[0].url === t.match.url && e[0].queryString === t.match.queryString) return e.forEach(function(n) {
                            n.route.hooks && n.route.hooks.already && d(t.navigateOptions, "callHooks") && n.route.hooks.already.forEach(function(n) {
                                return n(t.match);
                            });
                        }), void n(!1);
                        n();
                    },
                    function(t, n) {
                        t.match.route.hooks && t.match.route.hooks.before && d(t.navigateOptions, "callHooks") ? m(t.match.route.hooks.before.map(function(n) {
                            return function(e, o) {
                                return n(function(n) {
                                    !1 === n ? t.instance.__markAsClean(t) : o();
                                }, t.match);
                            };
                        }).concat([
                            function() {
                                return n();
                            }
                        ])) : n();
                    },
                    function(t, n) {
                        d(t.navigateOptions, "callHandler") && t.match.route.handler(t.match), t.instance.updatePageLinks(), n();
                    },
                    function(t, n) {
                        t.match.route.hooks && t.match.route.hooks.after && d(t.navigateOptions, "callHooks") && t.match.route.hooks.after.forEach(function(n) {
                            return n(t.match);
                        }), n();
                    }
                ], S = [
                    A,
                    function(t, n) {
                        var e = t.instance._notFoundRoute;
                        if (e) {
                            t.notFoundHandled = !0;
                            var o = h(t.currentLocationPath), r = o[0], i = o[1], a = u(t.to);
                            e.path = s(r);
                            var c = {
                                url: e.path,
                                queryString: i,
                                hashString: a,
                                data: null,
                                route: e,
                                params: "" !== i ? f(i) : null
                            };
                            t.matches = [
                                c
                            ], t.match = c;
                        }
                        n();
                    },
                    m.if(function(t) {
                        return t.notFoundHandled;
                    }, R.concat([
                        P
                    ]), [
                        function(t, n) {
                            t.resolveOptions && !1 !== t.resolveOptions.noMatchWarning && void 0 !== t.resolveOptions.noMatchWarning || console.warn('Navigo: "' + t.currentLocationPath + "\" didn't match any of the registered routes."), n();
                        },
                        function(t, n) {
                            t.instance._setCurrent(null), n();
                        }
                    ])
                ];
                function E() {
                    return (E = Object.assign || function(t) {
                        for(var n = 1; n < arguments.length; n++){
                            var e = arguments[n];
                            for(var o in e)Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
                        }
                        return t;
                    }).apply(this, arguments);
                }
                function x(t, n) {
                    var e = 0;
                    A(t, function o() {
                        e !== t.matches.length ? m(R, E({}, t, {
                            match: t.matches[e]
                        }), function() {
                            e += 1, o();
                        }) : P(t, n);
                    });
                }
                function H(t) {
                    t.instance.__markAsClean(t);
                }
                function j() {
                    return (j = Object.assign || function(t) {
                        for(var n = 1; n < arguments.length; n++){
                            var e = arguments[n];
                            for(var o in e)Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
                        }
                        return t;
                    }).apply(this, arguments);
                }
                var C = "[data-navigo]";
                function N(t, n) {
                    var e, o = n || {
                        strategy: "ONE",
                        hash: !1,
                        noMatchWarning: !1,
                        linksSelector: C
                    }, r = this, i = "/", d = null, w = [], L = !1, A = p(), P = v();
                    function R(t) {
                        return t.indexOf("#") >= 0 && (t = !0 === o.hash ? t.split("#")[1] || "/" : t.split("#")[0]), t;
                    }
                    function E(t) {
                        return s(i + "/" + s(t));
                    }
                    function N(t, n, e, o) {
                        return t = c(t) ? E(t) : t, {
                            name: o || s(String(t)),
                            path: t,
                            handler: n,
                            hooks: g(e)
                        };
                    }
                    function U(t, n) {
                        if (!r.__dirty) {
                            r.__dirty = !0, t = t ? s(i) + "/" + s(t) : void 0;
                            var e = {
                                instance: r,
                                to: t,
                                currentLocationPath: t,
                                navigateOptions: {},
                                resolveOptions: j({}, o, n)
                            };
                            return m([
                                y,
                                _,
                                m.if(function(t) {
                                    var n = t.matches;
                                    return n && n.length > 0;
                                }, x, S)
                            ], e, H), !!e.matches && e.matches;
                        }
                        r.__waiting.push(function() {
                            return r.resolve(t, n);
                        });
                    }
                    function q(t, n) {
                        if (r.__dirty) r.__waiting.push(function() {
                            return r.navigate(t, n);
                        });
                        else {
                            r.__dirty = !0, t = s(i) + "/" + s(t);
                            var e = {
                                instance: r,
                                to: t,
                                navigateOptions: n || {},
                                resolveOptions: n && n.resolveOptions ? n.resolveOptions : o,
                                currentLocationPath: R(t)
                            };
                            m([
                                k,
                                O,
                                _,
                                m.if(function(t) {
                                    var n = t.matches;
                                    return n && n.length > 0;
                                }, x, S),
                                b,
                                H
                            ], e, H);
                        }
                    }
                    function F() {
                        if (P) return (P ? [].slice.call(document.querySelectorAll(o.linksSelector || C)) : []).forEach(function(t) {
                            "false" !== t.getAttribute("data-navigo") && "_blank" !== t.getAttribute("target") ? t.hasListenerAttached || (t.hasListenerAttached = !0, t.navigoHandler = function(n) {
                                if ((n.ctrlKey || n.metaKey) && "a" === n.target.tagName.toLowerCase()) return !1;
                                var e = t.getAttribute("href");
                                if (null == e) return !1;
                                if (e.match(/^(http|https)/) && "undefined" != typeof URL) try {
                                    var o = new URL(e);
                                    e = o.pathname + o.search;
                                } catch (t) {}
                                var i = function(t) {
                                    if (!t) return {};
                                    var n, e = t.split(","), o = {};
                                    return e.forEach(function(t) {
                                        var e = t.split(":").map(function(t) {
                                            return t.replace(/(^ +| +$)/g, "");
                                        });
                                        switch(e[0]){
                                            case "historyAPIMethod":
                                                o.historyAPIMethod = e[1];
                                                break;
                                            case "resolveOptionsStrategy":
                                                n || (n = {}), n.strategy = e[1];
                                                break;
                                            case "resolveOptionsHash":
                                                n || (n = {}), n.hash = "true" === e[1];
                                                break;
                                            case "updateBrowserURL":
                                            case "callHandler":
                                            case "updateState":
                                            case "force":
                                                o[e[0]] = "true" === e[1];
                                        }
                                    }), n && (o.resolveOptions = n), o;
                                }(t.getAttribute("data-navigo-options"));
                                L || (n.preventDefault(), n.stopPropagation(), r.navigate(s(e), i));
                            }, t.addEventListener("click", t.navigoHandler)) : t.hasListenerAttached && t.removeEventListener("click", t.navigoHandler);
                        }), r;
                    }
                    function I(t, n, e) {
                        var o = w.find(function(n) {
                            return n.name === t;
                        }), r = null;
                        if (o) {
                            if (r = o.path, n) for(var a in n)r = r.replace(":" + a, n[a]);
                            r = r.match(/^\//) ? r : "/" + r;
                        }
                        return r && e && !e.includeRoot && (r = r.replace(new RegExp("^/" + i), "")), r;
                    }
                    function M(t) {
                        var n = h(s(t)), o = n[0], r = n[1], i = "" === r ? null : f(r);
                        return {
                            url: o,
                            queryString: r,
                            hashString: u(t),
                            route: N(o, function() {}, [
                                e
                            ], o),
                            data: null,
                            params: i
                        };
                    }
                    function T(t, n, e) {
                        return "string" == typeof n && (n = z(n)), n ? (n.hooks[t] || (n.hooks[t] = []), n.hooks[t].push(e), function() {
                            n.hooks[t] = n.hooks[t].filter(function(t) {
                                return t !== e;
                            });
                        }) : (console.warn("Route doesn't exists: " + n), function() {});
                    }
                    function z(t) {
                        return "string" == typeof t ? w.find(function(n) {
                            return n.name === E(t);
                        }) : w.find(function(n) {
                            return n.handler === t;
                        });
                    }
                    t ? i = s(t) : console.warn('Navigo requires a root path in its constructor. If not provided will use "/" as default.'), this.root = i, this.routes = w, this.destroyed = L, this.current = d, this.__freezeListening = !1, this.__waiting = [], this.__dirty = !1, this.__markAsClean = function(t) {
                        t.instance.__dirty = !1, t.instance.__waiting.length > 0 && t.instance.__waiting.shift()();
                    }, this.on = function(t, n, o) {
                        var r = this;
                        return "object" != typeof t || t instanceof RegExp ? ("function" == typeof t && (o = n, n = t, t = i), w.push(N(t, n, [
                            e,
                            o
                        ])), this) : (Object.keys(t).forEach(function(n) {
                            if ("function" == typeof t[n]) r.on(n, t[n]);
                            else {
                                var o = t[n], i = o.uses, a = o.as, s = o.hooks;
                                w.push(N(n, i, [
                                    e,
                                    s
                                ], a));
                            }
                        }), this);
                    }, this.off = function(t) {
                        return this.routes = w = w.filter(function(n) {
                            return c(t) ? s(n.path) !== s(t) : "function" == typeof t ? t !== n.handler : String(n.path) !== String(t);
                        }), this;
                    }, this.resolve = U, this.navigate = q, this.navigateByName = function(t, n, e) {
                        var o = I(t, n);
                        return null !== o && (q(o.replace(new RegExp("^/?" + i), ""), e), !0);
                    }, this.destroy = function() {
                        this.routes = w = [], A && window.removeEventListener("popstate", this.__popstateListener), this.destroyed = L = !0;
                    }, this.notFound = function(t, n) {
                        return r._notFoundRoute = N("*", t, [
                            e,
                            n
                        ], "__NOT_FOUND__"), this;
                    }, this.updatePageLinks = F, this.link = function(t) {
                        return "/" + i + "/" + s(t);
                    }, this.hooks = function(t) {
                        return e = t, this;
                    }, this.extractGETParameters = function(t) {
                        return h(R(t));
                    }, this.lastResolved = function() {
                        return d;
                    }, this.generate = I, this.getLinkPath = function(t) {
                        return t.getAttribute("href");
                    }, this.match = function(t) {
                        var n = {
                            instance: r,
                            currentLocationPath: t,
                            to: t,
                            navigateOptions: {},
                            resolveOptions: o
                        };
                        return _(n, function() {}), !!n.matches && n.matches;
                    }, this.matchLocation = function(t, n, e) {
                        void 0 === n || void 0 !== e && !e || (n = E(n));
                        var o = {
                            instance: r,
                            to: n,
                            currentLocationPath: n
                        };
                        return y(o, function() {}), "string" == typeof t && (t = void 0 === e || e ? E(t) : t), l(o, {
                            name: String(t),
                            path: t,
                            handler: function() {},
                            hooks: {}
                        }) || !1;
                    }, this.getCurrentLocation = function() {
                        return M(s(a(i)).replace(new RegExp("^" + i), ""));
                    }, this.addBeforeHook = T.bind(this, "before"), this.addAfterHook = T.bind(this, "after"), this.addAlreadyHook = T.bind(this, "already"), this.addLeaveHook = T.bind(this, "leave"), this.getRoute = z, this._pathToMatchObject = M, this._clean = s, this._checkForAHash = R, this._setCurrent = function(t) {
                        return d = r.current = t;
                    }, (function() {
                        A && (this.__popstateListener = function() {
                            r.__freezeListening || U();
                        }, window.addEventListener("popstate", this.__popstateListener));
                    }).call(this), F.call(this);
                }
            }
        }, n = {};
        function e(o) {
            if (n[o]) return n[o].exports;
            var r = n[o] = {
                exports: {}
            };
            return t[o](r, r.exports, e), r.exports;
        }
        return e.d = function(t, n) {
            for(var o in n)e.o(n, o) && !e.o(t, o) && Object.defineProperty(t, o, {
                enumerable: !0,
                get: n[o]
            });
        }, e.o = function(t, n) {
            return Object.prototype.hasOwnProperty.call(t, n);
        }, e(407);
    }().default;
});


function $4ea46448973b2734$export$c8a8987d4410bf2d(query, ns) {
    const { tag: tag, id: id, className: className } = $4ea46448973b2734$var$parse(query);
    const element = ns ? document.createElementNS(ns, tag) : document.createElement(tag);
    if (id) element.id = id;
    if (className) {
        if (ns) element.setAttribute("class", className);
        else element.className = className;
    }
    return element;
}
function $4ea46448973b2734$var$parse(query) {
    const chunks = query.split(/([.#])/);
    let className = "";
    let id = "";
    for(let i = 1; i < chunks.length; i += 2)switch(chunks[i]){
        case ".":
            className += ` ${chunks[i + 1]}`;
            break;
        case "#":
            id = chunks[i + 1];
    }
    return {
        className: className.trim(),
        tag: chunks[0] || "div",
        id: id
    };
}



/* global Node, ShadowRoot */ 


function $e5d3862746ca38ff$export$121e2d597d222bad(parent, child) {
    const parentEl = (0, $ace44be4a7f0f609$export$4f2058fac34d19ff)(parent);
    const childEl = (0, $ace44be4a7f0f609$export$4f2058fac34d19ff)(child);
    if (child === childEl && childEl.__redom_view) // try to look up the view if not provided
    child = childEl.__redom_view;
    if (childEl.parentNode) {
        $e5d3862746ca38ff$export$871462ad0a0666cb(child, childEl, parentEl);
        parentEl.removeChild(childEl);
    }
    return child;
}
function $e5d3862746ca38ff$export$871462ad0a0666cb(child, childEl, parentEl) {
    const hooks = childEl.__redom_lifecycle;
    if ($e5d3862746ca38ff$var$hooksAreEmpty(hooks)) {
        childEl.__redom_lifecycle = {};
        return;
    }
    let traverse = parentEl;
    if (childEl.__redom_mounted) (0, $5ecffabbcd710d1b$export$e614dc9140f7ae71)(childEl, "onunmount");
    while(traverse){
        const parentHooks = traverse.__redom_lifecycle || {};
        for(const hook in hooks)if (parentHooks[hook]) parentHooks[hook] -= hooks[hook];
        if ($e5d3862746ca38ff$var$hooksAreEmpty(parentHooks)) traverse.__redom_lifecycle = null;
        traverse = traverse.parentNode;
    }
}
function $e5d3862746ca38ff$var$hooksAreEmpty(hooks) {
    if (hooks == null) return true;
    for(const key in hooks){
        if (hooks[key]) return false;
    }
    return true;
}


const $5ecffabbcd710d1b$var$hookNames = [
    "onmount",
    "onremount",
    "onunmount"
];
const $5ecffabbcd710d1b$var$shadowRootAvailable = typeof window !== "undefined" && "ShadowRoot" in window;
function $5ecffabbcd710d1b$export$186d02efde07ef98(parent, child, before, replace) {
    const parentEl = (0, $ace44be4a7f0f609$export$4f2058fac34d19ff)(parent);
    const childEl = (0, $ace44be4a7f0f609$export$4f2058fac34d19ff)(child);
    if (child === childEl && childEl.__redom_view) // try to look up the view if not provided
    child = childEl.__redom_view;
    if (child !== childEl) childEl.__redom_view = child;
    const wasMounted = childEl.__redom_mounted;
    const oldParent = childEl.parentNode;
    if (wasMounted && oldParent !== parentEl) (0, $e5d3862746ca38ff$export$871462ad0a0666cb)(child, childEl, oldParent);
    if (before != null) {
        if (replace) {
            const beforeEl = (0, $ace44be4a7f0f609$export$4f2058fac34d19ff)(before);
            if (beforeEl.__redom_mounted) $5ecffabbcd710d1b$export$e614dc9140f7ae71(beforeEl, "onunmount");
            parentEl.replaceChild(childEl, beforeEl);
        } else parentEl.insertBefore(childEl, (0, $ace44be4a7f0f609$export$4f2058fac34d19ff)(before));
    } else parentEl.appendChild(childEl);
    $5ecffabbcd710d1b$var$doMount(child, childEl, parentEl, oldParent);
    return child;
}
function $5ecffabbcd710d1b$export$e614dc9140f7ae71(el, eventName) {
    if (eventName === "onmount" || eventName === "onremount") el.__redom_mounted = true;
    else if (eventName === "onunmount") el.__redom_mounted = false;
    const hooks = el.__redom_lifecycle;
    if (!hooks) return;
    const view = el.__redom_view;
    let hookCount = 0;
    view && view[eventName] && view[eventName]();
    for(const hook in hooks)if (hook) hookCount++;
    if (hookCount) {
        let traverse = el.firstChild;
        while(traverse){
            const next = traverse.nextSibling;
            $5ecffabbcd710d1b$export$e614dc9140f7ae71(traverse, eventName);
            traverse = next;
        }
    }
}
function $5ecffabbcd710d1b$var$doMount(child, childEl, parentEl, oldParent) {
    const hooks = childEl.__redom_lifecycle || (childEl.__redom_lifecycle = {});
    const remount = parentEl === oldParent;
    let hooksFound = false;
    for (const hookName of $5ecffabbcd710d1b$var$hookNames){
        if (!remount) {
            if (child !== childEl) {
                if (hookName in child) hooks[hookName] = (hooks[hookName] || 0) + 1;
            }
        }
        if (hooks[hookName]) hooksFound = true;
    }
    if (!hooksFound) {
        childEl.__redom_lifecycle = {};
        return;
    }
    let traverse = parentEl;
    let triggered = false;
    if (remount || traverse && traverse.__redom_mounted) {
        $5ecffabbcd710d1b$export$e614dc9140f7ae71(childEl, remount ? "onremount" : "onmount");
        triggered = true;
    }
    while(traverse){
        const parent = traverse.parentNode;
        const parentHooks = traverse.__redom_lifecycle || (traverse.__redom_lifecycle = {});
        for(const hook in hooks)parentHooks[hook] = (parentHooks[hook] || 0) + hooks[hook];
        if (triggered) break;
        else {
            if (traverse.nodeType === Node.DOCUMENT_NODE || $5ecffabbcd710d1b$var$shadowRootAvailable && traverse instanceof ShadowRoot || parent && parent.__redom_mounted) {
                $5ecffabbcd710d1b$export$e614dc9140f7ae71(traverse, remount ? "onremount" : "onmount");
                triggered = true;
            }
            traverse = parent;
        }
    }
}


/* global SVGElement */ 
function $4272eeb1725861e4$export$37a5fde709c1db82(view, arg1, arg2) {
    const el = (0, $ace44be4a7f0f609$export$4f2058fac34d19ff)(view);
    if (typeof arg1 === "object") for(const key in arg1)$4272eeb1725861e4$var$setStyleValue(el, key, arg1[key]);
    else $4272eeb1725861e4$var$setStyleValue(el, arg1, arg2);
}
function $4272eeb1725861e4$var$setStyleValue(el, key, value) {
    el.style[key] = value == null ? "" : value;
}



const $4bfdb0090cbf87f4$var$xlinkns = "http://www.w3.org/1999/xlink";
function $4bfdb0090cbf87f4$export$c609e428011345f3(view, arg1, arg2) {
    $4bfdb0090cbf87f4$export$62c450b99909af10(view, arg1, arg2);
}
function $4bfdb0090cbf87f4$export$62c450b99909af10(view, arg1, arg2, initial) {
    const el = (0, $ace44be4a7f0f609$export$4f2058fac34d19ff)(view);
    const isObj = typeof arg1 === "object";
    if (isObj) for(const key in arg1)$4bfdb0090cbf87f4$export$62c450b99909af10(el, key, arg1[key], initial);
    else {
        const isSVG = el instanceof SVGElement;
        const isFunc = typeof arg2 === "function";
        if (arg1 === "style" && typeof arg2 === "object") (0, $4272eeb1725861e4$export$37a5fde709c1db82)(el, arg2);
        else if (isSVG && isFunc) el[arg1] = arg2;
        else if (arg1 === "dataset") $4bfdb0090cbf87f4$export$3a6802af14bf5fa6(el, arg2);
        else if (!isSVG && (arg1 in el || isFunc) && arg1 !== "list") el[arg1] = arg2;
        else {
            if (isSVG && arg1 === "xlink") {
                $4bfdb0090cbf87f4$export$f419b8ecbd30f855(el, arg2);
                return;
            }
            if (initial && arg1 === "class") arg2 = el.className + " " + arg2;
            if (arg2 == null) el.removeAttribute(arg1);
            else el.setAttribute(arg1, arg2);
        }
    }
}
function $4bfdb0090cbf87f4$export$f419b8ecbd30f855(el, arg1, arg2) {
    if (typeof arg1 === "object") for(const key in arg1)$4bfdb0090cbf87f4$export$f419b8ecbd30f855(el, key, arg1[key]);
    else if (arg2 != null) el.setAttributeNS($4bfdb0090cbf87f4$var$xlinkns, arg1, arg2);
    else el.removeAttributeNS($4bfdb0090cbf87f4$var$xlinkns, arg1, arg2);
}
function $4bfdb0090cbf87f4$export$3a6802af14bf5fa6(el, arg1, arg2) {
    if (typeof arg1 === "object") for(const key in arg1)$4bfdb0090cbf87f4$export$3a6802af14bf5fa6(el, key, arg1[key]);
    else if (arg2 != null) el.dataset[arg1] = arg2;
    else delete el.dataset[arg1];
}


function $e4c54592668a5090$export$6f093cfa640b7166(str) {
    return document.createTextNode(str != null ? str : "");
}


function $ace44be4a7f0f609$export$63c5b6d6ff5b7ee1(element, args) {
    $ace44be4a7f0f609$export$f3ee6744e1ee588(element, args);
}
function $ace44be4a7f0f609$export$f3ee6744e1ee588(element, args, initial) {
    for (const arg of args){
        if (arg !== 0 && !arg) continue;
        const type = typeof arg;
        if (type === "function") arg(element);
        else if (type === "string" || type === "number") element.appendChild((0, $e4c54592668a5090$export$6f093cfa640b7166)(arg));
        else if ($ace44be4a7f0f609$export$8ee0fc9ee280b4ee($ace44be4a7f0f609$export$4f2058fac34d19ff(arg))) (0, $5ecffabbcd710d1b$export$186d02efde07ef98)(element, arg);
        else if (arg.length) $ace44be4a7f0f609$export$f3ee6744e1ee588(element, arg, initial);
        else if (type === "object") (0, $4bfdb0090cbf87f4$export$62c450b99909af10)(element, arg, null, initial);
    }
}
function $ace44be4a7f0f609$export$80adc1545b8555b7(parent) {
    return typeof parent === "string" ? (0, $0968745c4fdf3fa1$export$c0bb0b647f701bb5)(parent) : $ace44be4a7f0f609$export$4f2058fac34d19ff(parent);
}
function $ace44be4a7f0f609$export$4f2058fac34d19ff(parent) {
    return parent.nodeType && parent || !parent.el && parent || $ace44be4a7f0f609$export$4f2058fac34d19ff(parent.el);
}
function $ace44be4a7f0f609$export$8ee0fc9ee280b4ee(arg) {
    return arg && arg.nodeType;
}


function $0968745c4fdf3fa1$export$c0bb0b647f701bb5(query, ...args) {
    let element;
    const type = typeof query;
    if (type === "string") element = (0, $4ea46448973b2734$export$c8a8987d4410bf2d)(query);
    else if (type === "function") {
        const Query = query;
        element = new Query(...args);
    } else throw new Error("At least one argument required");
    (0, $ace44be4a7f0f609$export$f3ee6744e1ee588)((0, $ace44be4a7f0f609$export$4f2058fac34d19ff)(element), args, true);
    return element;
}
const $0968745c4fdf3fa1$export$c3da0dad1b44eea9 = $0968745c4fdf3fa1$export$c0bb0b647f701bb5;
const $0968745c4fdf3fa1$export$dda1d9f60106f0e9 = $0968745c4fdf3fa1$export$c0bb0b647f701bb5;
$0968745c4fdf3fa1$export$c0bb0b647f701bb5.extend = function extendHtml(...args) {
    return $0968745c4fdf3fa1$export$c0bb0b647f701bb5.bind(this, ...args);
};




function $38a9cc811e3653a2$export$d4cb3dfdb7a8fc7d(parent, ...children) {
    const parentEl = (0, $ace44be4a7f0f609$export$4f2058fac34d19ff)(parent);
    let current = $38a9cc811e3653a2$var$traverse(parent, children, parentEl.firstChild);
    while(current){
        const next = current.nextSibling;
        (0, $e5d3862746ca38ff$export$121e2d597d222bad)(parent, current);
        current = next;
    }
}
function $38a9cc811e3653a2$var$traverse(parent, children, _current) {
    let current = _current;
    const childEls = Array(children.length);
    for(let i = 0; i < children.length; i++)childEls[i] = children[i] && (0, $ace44be4a7f0f609$export$4f2058fac34d19ff)(children[i]);
    for(let i = 0; i < children.length; i++){
        const child = children[i];
        if (!child) continue;
        const childEl = childEls[i];
        if (childEl === current) {
            current = current.nextSibling;
            continue;
        }
        if ((0, $ace44be4a7f0f609$export$8ee0fc9ee280b4ee)(childEl)) {
            const next = current && current.nextSibling;
            const exists = child.__redom_index != null;
            const replace = exists && next === childEls[i + 1];
            (0, $5ecffabbcd710d1b$export$186d02efde07ef98)(parent, child, current, replace);
            if (replace) current = next;
            continue;
        }
        if (child.length != null) current = $38a9cc811e3653a2$var$traverse(parent, child, current);
    }
    return current;
}


const $efd3ba4ec2608b1d$var$ghpPathPart = "/skillbox-npm-less2-4/";
const $efd3ba4ec2608b1d$var$router = new (0, (/*@__PURE__*/$parcel$interopDefault($f993037a9863bffd$exports)))(window.location.pathname.includes($efd3ba4ec2608b1d$var$ghpPathPart) ? $efd3ba4ec2608b1d$var$ghpPathPart : "/");
function $efd3ba4ec2608b1d$var$navigate(event) {
    event.preventDefault();
    $efd3ba4ec2608b1d$var$router.navigate(event.target.getAttribute("href"));
}
function $efd3ba4ec2608b1d$var$postList() {
    const list = (0, $0968745c4fdf3fa1$export$c3da0dad1b44eea9)("ul", (0, $0968745c4fdf3fa1$export$c3da0dad1b44eea9)("li", "Loading..."));
    fetch("https://gorest.co.in/public/v2/posts/").then(async (response)=>{
        const data = await response.json();
        (0, $38a9cc811e3653a2$export$d4cb3dfdb7a8fc7d)(list, data.map((post)=>(0, $0968745c4fdf3fa1$export$c3da0dad1b44eea9)("li", (0, $0968745c4fdf3fa1$export$c3da0dad1b44eea9)("a", {
                href: `/post/${post.id}`,
                onclick: $efd3ba4ec2608b1d$var$navigate
            }, post.title))));
    });
    return (0, $0968745c4fdf3fa1$export$c3da0dad1b44eea9)("div", {
        className: "container"
    }, [
        (0, $0968745c4fdf3fa1$export$c3da0dad1b44eea9)("h1", "Post list"),
        list
    ]);
}
function $efd3ba4ec2608b1d$var$postPage(id) {
    const body = (0, $0968745c4fdf3fa1$export$c3da0dad1b44eea9)("p", "Loading...");
    fetch(`https://gorest.co.in/public/v2/posts/${id}`).then(async (response)=>{
        const post = await response.json();
        (0, $38a9cc811e3653a2$export$d4cb3dfdb7a8fc7d)(body, [
            (0, $0968745c4fdf3fa1$export$c3da0dad1b44eea9)("h2", post.title),
            (0, $0968745c4fdf3fa1$export$c3da0dad1b44eea9)("p", post.body),
            (0, $0968745c4fdf3fa1$export$c3da0dad1b44eea9)("a", {
                href: `/`,
                onclick: $efd3ba4ec2608b1d$var$navigate
            }, "\u0412\u0435\u0440\u043D\u0443\u0442\u044C\u0441\u044F \u043A \u0441\u043F\u0438\u0441\u043A\u0443")
        ]);
    });
    return (0, $0968745c4fdf3fa1$export$c3da0dad1b44eea9)("div", {
        className: "container"
    }, [
        (0, $0968745c4fdf3fa1$export$c3da0dad1b44eea9)("h1", "Post"),
        body
    ]);
}
$efd3ba4ec2608b1d$var$router.on(`/`, ()=>{
    (0, $38a9cc811e3653a2$export$d4cb3dfdb7a8fc7d)(document.body, $efd3ba4ec2608b1d$var$postList());
});
$efd3ba4ec2608b1d$var$router.on(`/post/:id`, ({ data: { id: id } })=>{
    (0, $38a9cc811e3653a2$export$d4cb3dfdb7a8fc7d)(document.body, $efd3ba4ec2608b1d$var$postPage(id));
});
$efd3ba4ec2608b1d$var$router.resolve();


//# sourceMappingURL=index.b4403603.js.map
